/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Body } from '../../../components/Text';
import IconNotice from '../../../components/icons/IconNotice';
import ContentError from '../../../contentViews/ContentError';
import FilePickerButton from '../../../components/buttons/FilePickerButton';
import AppNavFile from '../../../components/appNav/AppNavFile';

const ProfilePhotoError = (props) => (
  <div style={{ height: '100%' }}>
    <AppNavFile
      doneWithFile={props.doneWithFile}
    />

    <ContentError
      mainImage={<IconNotice color="neutral" size="200" />}
      explanation="profilePhotoInvalid.error.message.text"
    >
      <FilePickerButton accept="image/*" onChange={props.selectFile}>
        <Body color="white">
          <FormattedMessage id="profilePhotoInvalid.selectAnotherPhoto.button.label" />
        </Body>
      </FilePickerButton>
    </ContentError>
  </div>
);
ProfilePhotoError.propTypes = {
  selectFile: PropTypes.func,
  doneWithFile: PropTypes.func.isRequired,
};

export default ProfilePhotoError;
